import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK_GREETING = "Namaste! I'm Payal from IronByte. How can I help you with your metal requirements today?";
const ERROR_REPLY = "Sorry, connection issue. Please try again or email sales@ironbyte.in";

function getSessionId() {
  const stored = sessionStorage.getItem("ib_chat_session");
  if (stored) return stored;
  const id = "chat_" + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
  sessionStorage.setItem("ib_chat_session", id);
  return id;
}

export function useChatSession(open) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [sessionId] = useState(getSessionId);

  const post = useCallback((message) => axios.post(`${API}/chat/message`, { session_id: sessionId, message }), [sessionId]);

  useEffect(() => {
    if (!open || initialized) return;
    setInitialized(true);
    setLoading(true);
    post("Hi")
      .then(({ data }) => setMessages([{ role: "assistant", content: data.reply }]))
      .catch(() => setMessages([{ role: "assistant", content: FALLBACK_GREETING }]))
      .finally(() => setLoading(false));
  }, [open, initialized, post]);

  const sendMessage = useCallback(async (text) => {
    if (!text || loading) return;
    setMessages((prev) => [...prev, { role: "user", content: text }]);
    setLoading(true);
    try {
      const { data } = await post(text);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: data.reply },
        ...(data.enquiry_saved ? [{ role: "system", content: "Enquiry saved! Our sales team will review it shortly." }] : []),
      ]);
    } catch {
      setMessages((prev) => [...prev, { role: "assistant", content: ERROR_REPLY }]);
    } finally {
      setLoading(false);
    }
  }, [loading, post]);

  return { messages, loading, sendMessage };
}
